import { css } from "@emotion/react";
import { Font } from "@moneyforward/mfx_biz_react_components";

export const Aritcle = ({
  articleNumber,
  articleTitle,
  children,
}: {
  articleNumber: number;
  articleTitle: string;
  children: React.ReactNode;
}) => {
  return (
    <div>
      <Font variant="mb" component="h2">
        {`第${toFullWidth(articleNumber)}条 （${articleTitle}）`}
      </Font>
      <div css={descriptionStyle}>{children}</div>
    </div>
  );
};

/**
 * Converts a number to its full-width representation.
 * Full-width characters are often used in East Asian typography.
 *
 * This function converts each digit of the number to its corresponding full-width character.
 *
 * @param {number} num - The number to be converted to full-width.
 * @returns {string} The full-width representation of the number as a string.
 */
const toFullWidth = (num: number) => {
  return num.toString().replace(/[0-9]/g, function (match) {
    return String.fromCharCode(match.charCodeAt(0) + 0xfee0);
  });
};

const descriptionStyle = css`
  margin-top: 1.6rem;
`;
